import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "../../../../link";
import { Typo } from "../../../../typography";
import styled from "styled-components";
export const TransparentLayer = styled.div `
  &&& {
    pointer-events: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
  }
`;
export const BorderLayer = styled.div `
  &&& {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    box-sizing: border-box;
    border: 1px solid transparent;
    pointer-events: none;
  }
`;
export const StyledParagraphContainer = styled.div `
  padding: 0.5rem 0 0.5rem 0;
`;
export const StyledParagraph = styled.p `
  &&& {
    position: relative;
    margin: 0;
    ${({ theme, fontSize }) => `font-size: ${fontSize === "p1"
    ? theme.fontTokens.font11[0]
    : theme.fontTokens.font12[0]};`}
    ${({ theme, fontSize }) => `line-height: ${fontSize === "p1"
    ? theme.fontTokens.font11[1]
    : theme.fontTokens.font12[1]};`}
    ${({ theme }) => `font-weight: ${theme.fontWeights.normal};`}
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: ${({ theme, backgroundtype }) => backgroundtype === "light" ? theme.colors.black : theme.colors.white};
  }
`;
export const StyledTypo = styled((props) => (_jsx(Typo, Object.assign({}, props)))) `
  &&& {
    position: relative;
    margin: 0;
    word-break: break-word;
    color: ${({ theme, backgroundtype }) => backgroundtype === "light" ? theme.colors.black : theme.colors.white};
    span {
      display: block;
    }
  }
`;
export const StyledLink = styled((props) => _jsx(Link, Object.assign({}, props))) `
  &&& {
    cursor: pointer;
    ${({ fontSize }) => `font-size: ${fontSize === "p1" ? "16px" : "14px"};`}
  }
`;
